import { createTheme } from '@material-ui/core';
import customPalette from './custom/palette';
import customTypography from './custom/typography';
import spacing from './custom/spacing';

const themeConfig = {
    spacing,
    custom: {
        palette: customPalette,
        typography: customTypography,
    },
    breakpoints: {
        xs: '0px',
        sm: '600px',
        md: '960px',
        lg: '1280px',
        xl: '1900px',
        xxl: '2500px',
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1900,
            xxl: 2500,
        },
    },
    palette: {
        primary: {
            main: customPalette.primary,
        },
        secondary: {
            main: customPalette.secondary,
        },
        tertiary: {
            main: customPalette.darkGrey1,
        },
        background: {
            default: customPalette.background,
        },
        action: {
            disabled: customPalette.grey,
        },
    },
    overrides: {
        MuiDialogTitle: {
            root: {
                color: customPalette.secondary,
                background: customPalette.dialogTitleBackground,
            },
        },
        MuiDialogActions: {
            root: {
                color: customPalette.secondary,
                background: customPalette.dialogTitleBackground,
            },
        },
        MuiTypography: {
            h6: {
                lineHeight: '3rem',
            },
        },
        MuiButton: {
            outlinedSecondary: {
                background: customPalette.darkGrey1,
                '&:hover': {
                    backgroundColor: customPalette.darkGrey1,
                },
                '&.Mui-disabled': {
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    cursor: 'not-allowed',
                },
            },
            contained: {
                backgroundColor: customPalette.white,
                '&.Mui-disabled': {
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    cursor: 'not-allowed',
                },
            },
        },
        root: {},
        MuiMenu: {
            paper: {
                borderRadius: '0 0 8px 8px ',
                boxShadow: 'none',
                border: '1px solid ' + customPalette.darkGrey1,
            },
        },
        MuiList: {
            root: {
                background: customPalette.darkGrey1,
                color: customPalette.white,
                borderRadius: '0',
            },
        },
        MuiListItem: {
            root: {
                background: customPalette.darkGrey1,
                color: customPalette.white,
                '&:hover': {
                    backgroundColor: customPalette.black,
                },
            },
        },
    },
};

export default createTheme(themeConfig);
